import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { BookkeepingSidePanelDetails } from "./BookkeepingSidePanelDetails";

interface BookkeepingSidePanelProps {
  bookkeepingId: number
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
}

export const BookkeepingSidePanel = (props: BookkeepingSidePanelProps) => {
  if (!site.permissions.canConfigureSystemSettings) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <DetailSidePanel
    apiCall={() => window.CoreApi.Bookkeeping.GetSidePanelData(props.bookkeepingId)}
    apiKey="bookkeeping"
    entityId={props.bookkeepingId}
    title={RESX.Bookkeeping.resxBookkeeping}
    footerContent={<>
      {site.permissions.canConfigureSystemSettings && <ButtonPrimary href={routes.bookkeeping_Detail(props.bookkeepingId).absolute} label={RESX.Buttons.DetailView} />}
    </>}
    trigger={props.trigger}
  >
    {(bookkeeping) => <BookkeepingSidePanelDetails
      bookkeeping={bookkeeping}
    />}
  </DetailSidePanel>
}